import { gql } from "@apollo/client";

const GET_PRODUCT_FEATURES = gql`
  query GetProductFeatures {
    getProductFeatures
  }
`;

export default GET_PRODUCT_FEATURES;
